// The streak in the toolbar (28 Oct 2026): the flame and the working-day streak, quiet until the day's first use and in the tint after it;
// it opens the leaderboard. Nothing shows before the person has any points.
import { Link } from "react-router";
import { Flame } from "lucide-react";
import { formatNumber, useLocale, useTranslation } from "@ncp/i18n";
import { useEngagementMe } from "./api";
import { k } from "./parts";
import "./chip.css";

export function StreakChip() {
  const { t } = useTranslation();
  const { locale } = useLocale();
  const me = useEngagementMe().data;
  if (!me || me.points.total <= 0) return null;
  const label = t(k("chip.label"), { count: me.streak.current, level: me.level.number, points: formatNumber(me.points.total, locale) });
  return (
    <Link to="/leaderboard" className="es-icon-btn eg-chip" data-live={me.streak.activeToday || undefined} aria-label={label} title={label} data-testid="eg-streak-chip">
      <Flame aria-hidden />
      <span className="tnum">{formatNumber(me.streak.current, locale)}</span>
    </Link>
  );
}
